/**
 * A privacy or permission chip on an item (visual contract v2 §8): toned by who can see the thing —
 * Private on the success wash, a space of yours on the warning wash, a partner's space on the
 * lavender categorical wash (its text is `text`, guaranteed on every categorical `soft`;
 * tests/contrast.ts). Radius 999, padding 4 × 10, 12 / 500, no icon. Text, not a control. The top
 * bar's pill is gone (TMMAPP-0161 item 3); the cards and rows keep this chip.
 */
import { Box, useTheme } from '@mui/material';
import { PILL_RADIUS, resolveTokens } from '@/theme';
import type { PrivacyChipContent } from './privacy';
import { privacyColours } from './privacyColours';

export function ToneChip({ tone, label }: PrivacyChipContent) {
  const tokens = resolveTokens(useTheme());
  const { background, ink } = privacyColours(tone, tokens);
  return (
    <Box
      component="span"
      data-tone-chip={tone}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        maxWidth: '100%',
        p: '4px 10px',
        borderRadius: `${PILL_RADIUS}px`,
        bgcolor: background,
        color: ink,
        fontSize: 12,
        lineHeight: '16px',
        fontWeight: 500,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {label}
    </Box>
  );
}
